import React from 'react';

const themes = {
	light: {
		background: '#FFF'
	},
	dark: {
		background: '#000'
	}
}

const context = React.createContext(themes.dark);

export default context;

